var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-2 -2)"},[React.createElement("g",{"transform":"translate(2 2)","key":0},React.createElement("path",{"d":"M14,26A12,12,0,1,1,26,14,12.035,12.035,0,0,1,14,26ZM14,3.714A10.286,10.286,0,1,0,24.286,14,10.316,10.316,0,0,0,14,3.714Z","transform":"translate(-2 -2)"})),React.createElement("g",{"transform":"translate(13.143 6.286)","key":1},React.createElement("path",{"d":"M21.857,19a.773.773,0,0,1-.429-.086l-6-3.429A.9.9,0,0,1,15,14.714V7.857a.857.857,0,0,1,1.714,0V14.2l5.571,3.171a.949.949,0,0,1,.343,1.2A1.023,1.023,0,0,1,21.857,19Z","transform":"translate(-15 -7)"}))]));
}

Clock.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Clock;

Clock.default = Clock;
